import keyEventHandler from "./keyEventHandler";

// Dropdown
Array.from(document.querySelectorAll('.dropdown')).forEach(function(dropdown) {

    let select = dropdown.querySelector('select');
    
    if (select) {

        select.style.display = 'none';
        let selectedOption = select.selectedOptions.length ? select.selectedOptions[0] : false;
        let selectOptions = Array.from(select.options);

        let isReadonly = dropdown.getAttribute('data-readonly') == 'true';

        dropdown.setAttribute('tabindex', '0');
        if (isReadonly) {
            dropdown.classList.add('dropdown--readonly');
        }

        let dropdownHead = document.createElement('div');
        dropdownHead.className = 'dropdown-head';

        let placeholder = select.getAttribute('placeholder');
        if (!placeholder) {
            placeholder = selectedOption ? selectedOption.innerText : 'Seçim yapmak için tıklayın...';
            dropdown.classList.toggle('dropdown--separator-selected', selectedOption.value !== undefined && !selectedOption.value.trim().length);
        }

        let headOutput = `<div class="dropdown-selection">`;

        if (dropdown.getAttribute('data-type') == 'sort') {
            headOutput += `<div class="dropdown-prefix">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.8396 20.1642V6.54645" stroke="#171725" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M20.9172 16.0681L16.8394 20.1648L12.7617 16.0681" stroke="#171725" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M6.91109 3.83289V17.4507" stroke="#171725" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M2.83344 7.929L6.91121 3.83234L10.989 7.929" stroke="#171725" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>`;
        }

        headOutput += `
                <p class="dropdown-placeholder">${placeholder}</p>
                <div class="dropdown-icon dropdown-icon--dropdown">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19 8.5L12 15.5L5 8.5" stroke="#171725" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <div class="dropdown-icon dropdown-icon--search">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="11.7666" cy="11.7666" r="8.98856" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18.0183 18.4851L21.5423 22" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>`;

        dropdownHead.innerHTML += headOutput;

        // OnMouseDown
        let hasAlreadyClicked = false;
        let isOutOfFocus = true;

        let tryToPositionDropdown = function() {

            let position = dropdownBody.getBoundingClientRect();            
            if (position.top < 0 || position.bottom > (window.innerHeight || document.documentElement.clientHeight)) {
                dropdownBody.scrollIntoView(false);
            }
        }

        dropdownHead.onclick = function(event) {
            if (!hasAlreadyClicked) {
                let isOpen = dropdown.className.indexOf('dropdown--active') !== -1;
                if (!isOpen) {
                    tryToPositionDropdown();
                } else {
                    clearItemsFilter();
                }
                dropdown.classList.toggle('dropdown--active', !isOpen);
            }
            hasAlreadyClicked = false;
        }

        dropdownHead.onmousedown = function(event) {
            if (isOutOfFocus) {
                hasAlreadyClicked = true;
            }
        }

        dropdown.onfocus = function(event) {
            isOutOfFocus = false;
            dropdown.classList.add('dropdown--active');
            tryToPositionDropdown();
        }

        dropdown.onfocusout = function(event) {
            dropdown.removeAttribute('data-focus');
            hasAlreadyClicked = false;
            isOutOfFocus = true;

            if (event.relatedTarget && event.relatedTarget.closest('.dropdown') === dropdown) {
                return false;
            }

            dropdown.classList.remove('dropdown--active');
        
            clearItemsFilter();
        }

        dropdown.appendChild(dropdownHead);

        let dropdownBody = document.createElement('div');
        dropdownBody.className = 'dropdown-body';
        dropdownBody.setAttribute('tabindex', '1');

        let dropdownItemList = document.createElement('div');
        dropdownItemList.className = 'dropdown-items';
        dropdownItemList.setAttribute('tabindex', '2');

        dropdownItemList.innerHTML = __dropdownGenerateItems(selectOptions, selectedOption);
        let dropdownItemElements = Array.from(dropdownItemList.querySelectorAll('.dropdown-item'));

        dropdownBody.appendChild(dropdownItemList);

        let dropdownPlaceholderElm = dropdownHead.querySelector('.dropdown-placeholder');

        dropdownBody.onclick = function(e) {
            let option = e.target.closest('[data-value]');

            if (option && !isReadonly) {
                let value = option.getAttribute('data-value');

                if (value != null && value.length > 0) {
                    select.value = value;
                    select.dispatchEvent(new Event('change'));
                    __dropdownSelectChanged(select);
                    clearItemsFilter();
                }
            }

            return false;
        }

        dropdown.appendChild(dropdownBody);

        let searchMemoryQuery = '';
        let searchMemoryTimeout = null;
        let foundValues = [];


        let filterItems = function() {

            let query = searchMemoryQuery.trim();
            foundValues = [];
            
            if (!query.length) {
                clearItemsFilter();
                return false;
            }

            let hasFound = false;

            dropdownItemElements.map(function(item) {

                let value = item.getAttribute('data-value');
                let label = item.querySelector('p') ? item.querySelector('p').innerText : item.innerText;

                if (value && label) {

                    value = value.toLocaleLowerCase('tr-TR');
                    label = label.toLocaleLowerCase('tr-TR');

                    if (foundValues.indexOf(value) !== -1) {
                        item.style.display = 'none';
                    } else {

                        if (value.indexOf(query) === -1 && label.indexOf(query) === -1) {
                            item.style.display = 'none';
                        } else {
                            foundValues.push(value);
                            hasFound = true;
                            item.style.display = '';
                        }

                    }

                } else {
                    item.style.display = 'none';
                }

            });

            if (!hasFound) {
                clearItemsFilter();
            }

        }


        let _tempPlaceholder = null;
        let _isSearching = false;

        let clearItemsFilter = function() {
            foundValues = [];
            searchMemoryQuery = '';
            clearTimeout(searchMemoryTimeout);

            dropdownItemElements.map(function(item) {
                item.style.display = '';
            });

            if (_isSearching) {
                _tempPlaceholder = null;

                let selectedOption = select.selectedOptions.length ? select.selectedOptions[0] : false;
                
                if (selectedOption) {
                    dropdownPlaceholderElm.innerText = selectedOption.innerText.trim();
                }
            
                dropdown.classList.toggle('dropdown--separator-selected', selectedOption.value !== undefined && !selectedOption.value.trim().length);

                dropdown.classList.remove('dropdown--searching');
                _isSearching = false;
            }
        }


        
        dropdown.addEventListener('keydown', function(event) {
            
            if (dropdown.className.indexOf('dropdown--active') !== -1) {
                let key = keyEventHandler(event);

                if (key.isAllowed) {

                    if (key.inAlphabet || key.key == 'Backspace') {
                        if (key.inAlphabet) {
                            if (!_tempPlaceholder) {
                                _tempPlaceholder = dropdownPlaceholderElm.innerText;
                                dropdown.classList.add('dropdown--searching');
                                _isSearching = true;
                            }
                            searchMemoryQuery += key.key;
                        } else if (key.key == 'Backspace' && searchMemoryQuery.trim().length >= 1) {
                            searchMemoryQuery = searchMemoryQuery.substr(0, searchMemoryQuery.length - 1);
                        }
                        dropdownPlaceholderElm.innerText = searchMemoryQuery;
                        filterItems();
                    }

                    clearTimeout(searchMemoryTimeout);

                    searchMemoryTimeout = setTimeout(function() {
                        searchMemoryQuery = '';
                        clearTimeout(searchMemoryTimeout);
                        searchMemoryTimeout = null;
                    }, 2000);
        

                    if (key.key == 'Enter' || key.key == 'Space' || key.key == 'Backspace' || key.key == 'Delete') {

                        if (key.key == 'Enter' && foundValues.length) {
                            select.value = foundValues[0];
                            select.dispatchEvent(new Event('change'));
                            __dropdownSelectChanged(select);
                            clearItemsFilter();
                        }

                        event.stopPropagation();
                        event.preventDefault();
                    }
                }
            }

        });

        // Scroll to selected item if there's one
        let alreadySelectedItem = dropdownBody.querySelector('.dropdown-item--selected');
        if (alreadySelectedItem) {
            alreadySelectedItem.scrollIntoView({ behavior: 'smooth', block: 'center'});
        }

        select.addEventListener('change', function() {
            __dropdownSelectChanged(this, true);
        });

        select.addEventListener('focus', function() {
            dropdown.classList.add('dropdown--active');
        });

        
        let observer = new MutationObserver(function(mutationsList, observer) {
            for(const mutation of mutationsList) {
                if (mutation.type === 'childList') {

                    selectedOption = select.selectedOptions.length ? select.selectedOptions[0] : false;
                    selectOptions = Array.from(select.options);

                    dropdownItemList.innerHTML = __dropdownGenerateItems(selectOptions, selectedOption);
                    dropdownItemElements = Array.from(dropdownItemList.querySelectorAll('.dropdown-item'));

                    __dropdownSelectChanged(select);
                }
            }
        });

        // Start observing select node for dynamic option changes
        observer.observe(select, { childList: true });        

    }

});

function __dropdownGenerateItems(options, current) {
    let output = '';

    for (let i = 0; i < options.length; i++) {

        let option = options[i];

        output += `<div class="dropdown-item`;
        if (option.value == undefined || option.value == null || !option.value.trim().length) {
            output += ` dropdown-item--disabled`;

            if (option.innerText == '-') {
                output += ` dropdown-item--separator`;
            }
        }

        if (current.value == option.value) {
            output += ` dropdown-item--selected`;
        }
        output += `" data-value="${option.value}"><p>${option.innerText}</p></div>`;
    }
    
    return output;
}

function __dropdownSelectChanged(select, stay_open) {

    stay_open = stay_open || false;

    let dropdown = select.closest('.dropdown');
    let dropdownHead = dropdown.querySelector('.dropdown-head');
    let dropdownBody = dropdown.querySelector('.dropdown-body');
    let dropdownPlaceholder = dropdownHead.querySelector('.dropdown-placeholder');

    let selectedOption = select.selectedOptions.length ? select.selectedOptions[0] : false;

    Array.from(dropdownBody.querySelectorAll('.dropdown-item--selected')).forEach(_ => _.classList.remove('dropdown-item--selected'));

    if (selectedOption) {
        Array.from(dropdownBody.querySelectorAll('[data-value="' + selectedOption.value + '"]')).forEach(_ => _.classList.add('dropdown-item--selected'));
        dropdownPlaceholder.innerText = selectedOption.innerText.trim();
    }

    dropdown.classList.toggle('dropdown--separator-selected', selectedOption.value !== undefined && !selectedOption.value.trim().length);

    if (!stay_open) {
        setTimeout(function() {
            dropdown.classList.remove('dropdown--active');
        }, 150);
    }
}